<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h1" id="d7e1156039" style="color: #82a339"><b>EGGS STUFFED WITH SMOKED <br/> SALMON AND CUCUMBERS</b></p>
<p class="ext" id="d7e1156839"><b><i>Make the filling up to a day before, then stuff the eggs well before your guests arrive. These light, fresh flavors are the perfect accompaniment to a spring celebration.</i></b></p>
<p class="h4" id="d7e1158139" style="color: #496210"><b>Prep: 30 minutes plus chilling       Cook: 15 minutes</b></p>
<p class="ul" id="d7e1158639">10 large eggs</p>
<p class="ul" id="d7e1158939">2 ounces smoked salmon, finely chopped (⅓ cup)</p>
<p class="ul" id="d7e1160039">3 tablespoons light mayonnaise</p>
<p class="ul" id="d7e1160339">¼ cup finely chopped cucumber</p>
<p class="ul" id="d7e1161339">2 teaspoons chopped fresh dill <br/> plus sprigs for garnish</p>
<p class="ul" id="d7e1161939">⅛ teaspoon ground black pepper</p>
<p class="pub" id="d7e1163139" style="margin-top: 1.5em;"><span style="color: #c15b49"><b>1.</b></span> In 4-quart saucepan, place eggs and enough <i>cold water </i>to cover by at least 1 inch; heat to boiling on high. Immediately remove saucepan from heat and cover tightly; let stand 15 minutes. Pour off hot water, and run cold water over eggs to cool. Peel eggs.</p>
<p class="pub" id="d7e1165839"><span style="color: #c15b49"><b>2.</b></span> Slice eggs lengthwise in half. Gently remove yolks and place in medium bowl; with fork, break yolks into chunks. Reserve 1 tablespoon chopped salmon and add remaining salmon to egg yolks. Add mayonnaise, cucumber, chopped dill, and pepper; gently stir until combined. (Egg-yolk mixture and egg whites can now be covered separately and refrigerated up to 24 hours.)</p>
<p class="pub" id="d7e1168739"><span style="color: #c15b49"><b>3.</b></span> Place egg whites on serving dish or in jelly-roll pan lined with paper towels (to prevent eggs from rolling). Spoon about 1 tablespoon egg-yolk mixture into each egg-white half. Top eggs with reserved chopped salmon. Cover eggs and refrigerate up to 4 hours. Just before serving, garnish with dill sprigs. Makes 20 appetizer servings.</p>
<p class="ntx" id="d7e1171839">Each serving: About 50 calories, 4g protein, 1g carbohydrate, 3g total fat (1g saturated), 0g fiber, 108mg cholesterol, 70mg sodium.</p>
<p class="ser"><img alt="9781618371621_0039_001" src="Images/9781618371621_0039_001.jpg" style="max-width:100%;"/></p>
<p class="cap" id="d7e1173039"><i>Eggs Stuffed with Smoked Salmon and Cucumbers</i></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c27_r1.vue?1d853dde